import { Dispatch } from 'react';
import { DeckAction, DeckState } from '../context/DeckContextV3';
import { Block, Edge, Segment } from 'src/types/shared/blocksV3';
import getDefaultDeckbox, {
	getDefaultDeckboxForEdge,
	getDefaultDeckboxForEdgeAndSegment,
} from './getDefaultDeckbox';

const handleAddDeckbox = ({
	state,
	dispatch,
	block,
	edge,
	segment,
}: {
	state: DeckState;
	dispatch: Dispatch<DeckAction>;
	block: Block | null | undefined;
	edge: Edge | null | undefined;
	segment?: Segment;
}) => {
	let defaultDeckbox;
	let updatedOldSegment;

	if (block && edge) {
		const data = segment
			? getDefaultDeckboxForEdgeAndSegment({
					parentBlock: block,
					selectedBlockEdge: edge,
					selectedBlockSegment: segment,
				})
			: getDefaultDeckboxForEdge({
					blocks: state.blocks,
					parentBlock: block,
					selectedBlockEdge: edge,
				});

		if (!data) {
			return;
		}

		defaultDeckbox = data.defaultDeckbox;
		updatedOldSegment = data.updatedOldSegment;
	} else {
		defaultDeckbox = getDefaultDeckbox();
	}

	if (updatedOldSegment && block) {
		const updatedBlock = { ...block };

		updatedBlock.edges = updatedBlock?.edges.map((ed) => {
			if (ed.id == edge?.id) {
				const updatedEdge = { ...ed };

				updatedEdge.segments = updatedEdge.segments.map((seg) => {
					if (seg.id == updatedOldSegment.id) {
						return { ...updatedOldSegment };
					}
					return seg;
				});

				return updatedEdge;
			} else {
				return ed;
			}
		});

		dispatch({
			type: 'UPDATE_BLOCK',
			payload: updatedBlock,
		});
	}

	if (defaultDeckbox) {
		dispatch({
			type: 'ADD_BLOCK',
			payload: defaultDeckbox,
		});

		// Commented out to keep modal open after adding deckbox
		// dispatch({
		// 	type: 'SELECT_EDGE',
		// 	payload: { blockId: null, edgeLabel: null },
		// });
	}
};

export default handleAddDeckbox;
